import script from "./infoChangeDepartment.vue?vue&type=script&setup=true&lang=js"
export * from "./infoChangeDepartment.vue?vue&type=script&setup=true&lang=js"

import "./infoChangeDepartment.vue?vue&type=style&index=0&id=7906f034&lang=scss&scoped=true"

import exportComponent from "D:\\workspace\\baoda\\salary\\wages-admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7906f034"]])

export default __exports__